/**
 * Single source of truth for Supabase Realtime channel names used by Rooms.
 *
 * All room realtime hooks should derive their channel name from this map so
 * presence, activity, and chat consistently align between clients.
 */
export const roomChannelNames = {
  presence: (roomId: string) => `room:presence:${roomId}`,
  activity: (roomId: string) => `room:activity:${roomId}`,
  chat: (roomId: string) => `room:chat:${roomId}`,
} as const;

export type RoomConnectionState =
  | "connecting"
  | "connected"
  | "reconnecting"
  | "disconnected";

export type RoomPresenceMember = {
  user_id: string;
  name: string;
  email: string | null;
  avatar_color?: string | null;
  online_at: string;
};

export type RoomTypingPayload = {
  user_id: string;
  name: string;
  typing: boolean;
};
